import type { ReactElement, CSSProperties } from 'react'
import { STROKE } from '../glyphs/shared'

interface SparkleProps {
  size?: number
  color?: string
  style?: CSSProperties
}

/**
 * 8-point sparkle / star shape. Pair with the .sparkle utility class
 * for the twinkling animation. Color defaults to gold.
 */
export const Sparkle = ({
  size = 16,
  color = '#ffd166',
  style,
}: SparkleProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={style}>
    <path
      d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z"
      fill={color}
      stroke={STROKE}
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
)
